/* SWL cart-properties bridge (2026-08-11)
   Horizon's buy-button component submits variant+qty via its own fetch and
   ignores VO Product Options inputs (they live in a separate /cart/add form),
   so line items arrived with NO color/print choices. This patch intercepts
   /cart/add requests and merges properties[...] values from the VO form. */
(function () {
  function voProps() {
    var props = {};
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var els = forms[i].querySelectorAll('[name^="properties["]');
      if (!els.length) continue;
      var fd = new FormData(forms[i]);
      fd.forEach(function (v, k) {
        var m = k.match(/^properties\[(.+)\]$/);
        if (m && v && typeof v === 'string') props[m[1]] = v;
      });
    }
    return props;
  }
  var of = window.fetch.bind(window);
  window.fetch = function (input, opts) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('/cart/add') !== -1 && opts && opts.body) {
        var props = voProps();
        var keys = Object.keys(props);
        if (keys.length) {
          if (opts.body instanceof FormData) {
            keys.forEach(function (k) {
              if (!opts.body.has('properties[' + k + ']')) opts.body.append('properties[' + k + ']', props[k]);
            });
          } else if (typeof opts.body === 'string' && opts.body.charAt(0) === '{') {
            var j = JSON.parse(opts.body);
            if (j.items && j.items.length) {
              j.items.forEach(function (it) { it.properties = Object.assign({}, props, it.properties || {}); });
            } else {
              j.properties = Object.assign({}, props, j.properties || {});
            }
            opts.body = JSON.stringify(j);
          } else if (typeof opts.body === 'string' && opts.body.indexOf('=') !== -1) {
            var extra = keys.map(function (k) {
              return encodeURIComponent('properties[' + k + ']') + '=' + encodeURIComponent(props[k]);
            }).join('&');
            opts.body += '&' + extra;
          }
        }
      }
    } catch (e) { /* never block the add */ }
    return of.apply(null, arguments);
  };
})();
